module.exports = __webpack_public_path__ + "static/media/logo_agribank.c7b89de6.svg";